import type { VehicleFeatures } from 'Pages/vehicles/helpers/vehicle.schema';

interface GetFeatureDisplayStatesParams {
	equipment: VehicleFeatures['equipment'];
	highValueCarFeatures: VehicleFeatures['highValueCarFeatures'];
	manuallyAddedAdditionalFeaturesTrimmed?: string;
}

interface GetFeatureDisplayStates {
	shouldShowEmptyState: boolean;
	shouldShowHighValueFeaturesList: boolean;
	shouldShowManuallyAddedAdditionalFeatures: boolean;
}

export const getFeatureDisplayStates = ({
	equipment,
	highValueCarFeatures,
	manuallyAddedAdditionalFeaturesTrimmed,
}: GetFeatureDisplayStatesParams): GetFeatureDisplayStates => {
	const equipmentItems = equipment ? equipment.split(',') : [];
	const hasHighValueCarFeatures = Boolean(highValueCarFeatures.items?.length);
	const highValueCarFeaturesHaveTotalCost = Boolean(highValueCarFeatures.totalCost);
	const hasHighValueCarFeaturesOrEquipment = hasHighValueCarFeatures || Boolean(equipmentItems.length);

	const shouldShowManuallyAddedAdditionalFeatures = Boolean(
		(!highValueCarFeaturesHaveTotalCost || !hasHighValueCarFeatures) && manuallyAddedAdditionalFeaturesTrimmed,
	);

	const shouldShowEmptyState = !hasHighValueCarFeaturesOrEquipment && !shouldShowManuallyAddedAdditionalFeatures;

	return {
		shouldShowEmptyState,
		shouldShowHighValueFeaturesList: hasHighValueCarFeaturesOrEquipment,
		shouldShowManuallyAddedAdditionalFeatures,
	};
};
